export const isLoggedIn = () => {
  const token = localStorage.getItem("token");
  return token?.length > 0 ? true : false;
};

export const getUserDetails = () => {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user) : null;
};

export const getToken = () => {
  const token = localStorage.getItem("token");
  return token?.length > 0 ? token : "";
};

export const percentage = (discountPrice, totalPrice) => {
  if (totalPrice <= 0) return "";

  const discountPercentage = Math.round(
    ((totalPrice - discountPrice) / totalPrice) * 100
  );

  return discountPercentage > 0 ? `${discountPercentage}% OFF` : "";
};

export const excerpt = (str, length) => {
  if (str && typeof str === "string") {
    let stringLength = str.length;
    if (stringLength > length) {
      str = str.substring(0, length) + " ... ";
    }
  }
  return str;
};

export const calculateTotalPrice = (cart) => {
  let total = 0;
  if (cart && cart?.length > 0) {
    cart?.forEach((item) => {
      total += Math.round(item?.quantity * item?.discount_price);
    });
  }
  return total;
};

export const isProductInWishList = (id) => {
  const products = JSON.parse(localStorage.getItem("wishlist")) || [];
  return products?.some((product) => product._id === id);
};

export const getPercentage = (number) => {
  if (number > 0) {
    const percentage = (number * 100) / 5;

    return percentage;
  } else {
    return 0;
  }
};

export const isProductReviewed = (orders, productId) => {
  for (const order of orders) {
    const product = order.productInfo.find(
      (item) => item.productId === productId
    );

    if (product && !product.reviewed) {
      return {
        orderId: order._id,
        productId: product.productId,
      };
    }
  }

  return false;
};

export const generateRandomInvoiceNumber = () => {
  const prefix = "INV";
  const randomNumber = Math.floor(100000 + Math.random() * 900000);
  const invoiceNumber = `${prefix}${randomNumber}`;
  return invoiceNumber;
};

export const getFormattedDate = () => {
  const today = new Date();

  // Get day, month, and year
  const day = today.getDate();
  const month = today.toLocaleString("default", { month: "short" });
  const year = today.getFullYear();

  // Return the formatted date
  return `${day} ${month} ${year}`;
};
